import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { articles as rawArticles } from "../data/articles";

const sortByDateDesc = (items: typeof rawArticles) =>
  [...items].sort((a, b) => {
    const [da, ma, ya] = a.date.split(".").map(Number);
    const [db, mb, yb] = b.date.split(".").map(Number);
    return yb - ya || mb - ma || db - da;
  });

export const Footer: React.FC = () => {
  const footerArticles = useMemo(() => sortByDateDesc(rawArticles).slice(0, 3), []);

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__col">
          <p className="eyebrow">Последние статьи</p>
          <ul className="footer__list">
            {footerArticles.map((art) => (
              <li key={art.slug}>
                <Link to={`/articles/${art.slug}`}>{art.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer__col">
          <p className="eyebrow">Контакты</p>
          <ul className="footer__contacts">
            <li>
              <a href="tel:+79269498006">+7 926 949-80-06</a>
            </li>
            <li>
              <a href="mailto:dr.oganov1@yandex.ru" target="_blank" rel="noreferrer">
                dr.oganov1@yandex.ru
              </a>
            </li>
            <li>
              <a href="https://t.me/docneuro1" target="_blank" rel="noreferrer">
                Telegram: @docneuro1
              </a>
            </li>
            <li>
              <a
                href="https://api.whatsapp.com/send/?phone=79269498006&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
